import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { RoleCode } from '../../../../../domain/consts';
import { Offer, PolicyholderRequest } from '../../../../../domain/offer.domain';
import { Party } from '../../../../../domain/party.domain';
import { EntityRole } from '../../../../../domain/user.model';
import { OfferAction } from '../../../store/offer.action';

@Component({
    selector: 'app-clients-box',
    templateUrl: './clients-box.component.html',
    styleUrls: ['./clients-box.component.scss']
})
export class ClientsBoxComponent {

    @Input() offer: Offer;
    @Input() readonly: boolean = false;

    get partyList(): Party[] {
        const used = [this.policyholderId];
        const result: Party[] = [this.offer.partyList.find(p => p.id === this.policyholderId)];
        this.offer.partyList.forEach(p => {
            if (used.indexOf(p.id) === -1) {
                result.push(p);
                used.push(p.id);
            }
        });
        return result.filter(e => e);
    }

    get policyholderId() {
        const role = this.offer.partyRoleList.find(e => e.role === RoleCode.POLICYHOLDER);
        return role
            ? role.partyId
            : null;
    }

    get isPolicyholderInsured() {
        const policyholderId = this.policyholderId;
        return this.offer.partyRoleList
            .filter(e => e.partyId === policyholderId && e.role === RoleCode.INSURED_PERSON).length > 0;
    }

    get numberOfInsured() {
        const policyholderId = this.policyholderId;
        return this.offer.partyRoleList
            .filter(e => e.partyId !== policyholderId && e.role === RoleCode.INSURED_PERSON).length;
    }

    constructor(private store: Store) {
    }

    personLabel(person: Party) {
        if (person.id === this.policyholderId) {
            return this.isPolicyholderInsured
                ? 'LABEL.POLICYHOLDER_INSURED'
                : 'LABEL.POLICYHOLDER';
        }
        return 'LABEL.INSURED';
    }

    personAddressLabel(person: Party) {
        return person.otherCorrespondenceAddress
            ? 'LABEL.ADDRESS'
            : 'LABEL.BOTH_ADDRESSES';
    }

    edit(party: Party) {
        if (party.id === this.policyholderId) {
            const request = new PolicyholderRequest();
            request.policyholder = party;
            request.policyholderIsInsuredPerson = this.offer.partyRoleList
                .filter(r => r.partyId === party.id && r.role === RoleCode.INSURED_PERSON).length > 0;
            this.store.dispatch(new OfferAction.EditPolicyholder(this.offer.id, request));
        } else {
            this.store.dispatch(new OfferAction.EditInsured(this.offer.id, party));
        }

    }

    delete(party: Party) {
        this.store.dispatch(new OfferAction.DeleteInsured(this.offer.id, party));
    }

    addInsured() {
        this.store.dispatch(new OfferAction.EditInsured(this.offer.id, new Party()));
    }
}
